import { render } from "./OurServices.vue?vue&type=template&id=91df4b3a&scoped=true"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"

import "./OurServices.vue?vue&type=style&index=0&id=91df4b3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91df4b3a"]])

export default __exports__